import React, { useRef, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import cn from "clsx";

import { toastreact } from "./../../components/ToastMessage";
import { toastMessageTypes } from "./../../components/ToastMessage/constants";

import {
  betTypesForBetsContainer,
  ballsColorColumns,
  MAX_CHECKED_BALLS,
  MIN_CHECKED_BALLS,
  MAX_BALL_NUMBER,
  colors,
  MAX_CHECKED_BALL_COLOR,
  betTypesForBetBetslip,
  lifecycleStates,
  betTypeForBetName,
  specifierValueForSpecialBets,
  colorsAsNumbers,
} from "./../../utils/constants";

import {
  getOddByBetTypeAndSpecifier,
  betAlreadyInBetsObject,
} from "./../../utils/helpers";

import "./../../scss/Bets/index.scss";

import { useGlobalDataContext } from "../../../GlobalDataContext";
import Countdown from "../../components/Countdown/Countdown";

// disable adding bets in betslip
const OddsFoBet = () => {
  const { state, dispatch } = useGlobalDataContext();
  const { t } = useTranslation();

  const [bet, setBet] = useState({
    betType: betTypesForBetsContainer.CUSTOM,
    odd: null,
    result: [],
  });
  const [betForColors, setBetForColors] = useState({
    betType: betTypesForBetsContainer.MOST_FREQUENT_COLOR,
    odd: null,
    result: [],
  });
  const [betSpecials, setBetSpecials] = useState({
    betType: null,
    odd: null,
    result: [],
  });
  const [ballsColumns, setBallCollumns] = useState({ ...ballsColorColumns });
  const [wrong, setWrong] = useState(false);
  useEffect(() => {
    window.addEventListener("keypress", OddsOnKeyPressEventListener);
    return () => {
      window.removeEventListener("keypress", OddsOnKeyPressEventListener);
    };
  }, []);

  const buttonAddBet = useRef(null);
  const buttonRemoveBet = useRef(null);
  const buttonSelectRandomBet = useRef(null);
  const buttonSelectAllColorsBet = useRef(null);
  const buttonPreBallNumber = useRef(null);

  // disable adding bets in betslip
  const [disableBetslip, setDisableBetslip] = useState("all");

  // click on ball when CUSTOM or RANDOM or PRE BALLS NUMBER bet type is active
  const clickForBetTypeActive = (columnColor, ballNumber, target) => {
    let ballsNumbers = [...bet.result];
    if (bet.result.includes(ballNumber)) {
      ballsNumbers.splice(bet.result.indexOf(ballNumber), 1);
      setBallCollumns({
        ...ballsColumns,
        [columnColor]: {
          ...ballsColumns[columnColor],
          [ballNumber]: !ballsColumns[columnColor][ballNumber],
        },
      });
    } else {
      ballsNumbers =
        bet.result.length === MAX_CHECKED_BALLS
          ? [...bet.result]
          : [...bet.result, ballNumber];
    }

    setBet({
      betType: betTypesForBetsContainer.CUSTOM,
      odd: null,
      result: ballsNumbers,
    });

    if (
      bet.result.length === MAX_CHECKED_BALLS &&
      !target.classList.contains("active")
    ) {
      toastreact({
        type: toastMessageTypes.WARN,
        title: t("oddsContent.pickMaxNumber").replace(
          "MAX_CHECKED_BALLS",
          MAX_CHECKED_BALLS
        ),
      });
      return;
    }
    setBallCollumns({
      ...ballsColumns,
      [columnColor]: {
        ...ballsColumns[columnColor],
        [ballNumber]: !ballsColumns[columnColor][ballNumber],
      },
    });
  };

  // click ball when ALL COLOR bet type is activated
  const clickWhenAllColorBetTypeActive = (columnColor, ballNumber) => {
    setBet({
      betType: betTypesForBetsContainer.CUSTOM,
      odd: null,
      result: [...[], ballNumber],
    });
    setBallCollumns(getSetOfBalls([ballNumber]));
  };

  const onInputClickEventListener = (event) => {
    event.preventDefault();
    if (event.target.value < 1 || event.target.value > 48)
      return (event.target.value = false);

    let newArr = [];
    let inputNow = document.getElementsByClassName("bet-input-numbers");
    for (let x = 0; x < inputNow.length; x++) {
      if (inputNow[x].value.length > 0) {
        if (newArr.includes(Number(inputNow[x].value))) return setWrong(true);
        if (Number(inputNow[x].value.length > 2)) return setWrong(true);
        if (Number(inputNow[x].value > 48)) return setWrong(true);
        if (Number(inputNow[x].value < 1)) return setWrong(true);
        setBallCollumns(getSetOfBalls());
        newArr.push(Number(inputNow[x].value));
        setWrong(false);
      }
    }
    setBet({
      betType: betTypesForBetsContainer.CUSTOM,
      odd: null,
      result: [...newArr],
    });
  };
  // click on balls
  const onBallClickEventListener = (event) => {
    clearBallInput();
    clearBallColor();
    clearSpecialBet();
    const columnColor = event.currentTarget.getAttribute("data-color-column");
    const ballNumber = event.currentTarget.getAttribute("data-ball-number");

    if (bet.betType === betTypesForBetsContainer.ALL_COLORS) {
      clickWhenAllColorBetTypeActive(columnColor, Number(ballNumber));
    } else {
      clickForBetTypeActive(
        columnColor,
        Number(ballNumber),
        event.currentTarget
      );
    }
  };

  // click on the bottom circle under the number column
  const checkNumbersByColor = (color) => {
    clearBallColor();
    clearSpecialBet();
    clearBallsNumbers();

    const isColumnAlreadyChecked =
      bet.result.length &&
      [...bet.result].every((item) => {
        return Object.keys(ballsColumns[color])
          .map((item) => Number(item))
          .includes(Number(item));
      });

    const numbersForOneColor = isColumnAlreadyChecked
      ? []
      : Object.keys(ballsColumns[color]).map((item) => Number(item));

    setBet({
      betType: betTypesForBetsContainer.CUSTOM,
      odd: null,
      result: [...numbersForOneColor],
    });
    if (isColumnAlreadyChecked) {
      setBallCollumns(getSetOfBalls());
    } else {
      setBallCollumns(getSetOfBallsByOneColor(color));
    }
  };

  // click on all colors button
  const onAllColorsClickEventListener = () => {
    clearBallColor();
    clearSpecialBet();
    const allColorsBalls = [...Array(MAX_BALL_NUMBER + 1).keys()].slice(1);
    setBet({
      betType: betTypesForBetsContainer.ALL_COLORS,
      odd: null,
      result: allColorsBalls,
    });
    setBallCollumns(getSetOfBalls(allColorsBalls));
  };

  // click on preballs number button
  const onPreBallsNumberClickEventListener = () => {
    clearBallColor();
    clearSpecialBet();
    if (bet.result.length === 1) {
      setBet({
        betType: betTypesForBetsContainer.PRE_BALL_NUMBER,
        odd: null,
        result: [...bet.result],
      });
    } else {
      toastreact({
        type: toastMessageTypes.WARN,
        title: t("oddsContent.selectOneNumber"),
      });
      setBet({
        betType: betTypesForBetsContainer.CUSTOM,
        odd: null,
        result: [],
      });
      if (bet.result.length > 1) {
        setBallCollumns(getSetOfBalls());
      }
    }
  };

  // click on Random button
  const onRandomClickEventListener = () => {
    clearBallColor();
    clearSpecialBet();
    const allBallsArray = [...Array(MAX_BALL_NUMBER + 1).keys()].slice(1);
    const randomResult = [];
    [...Array(MIN_CHECKED_BALLS).keys()].map((item) => {
      let randomNumber = Math.ceil(
        Math.random() *
          (allBallsArray[allBallsArray.length - 1] - allBallsArray[0]) +
          allBallsArray[0]
      );
      // push only unique numbers in array
      while (randomResult.includes(randomNumber)) {
        randomNumber = Math.ceil(
          Math.random() *
            (allBallsArray[allBallsArray.length - 1] - allBallsArray[0]) +
            allBallsArray[0]
        );
      }

      randomResult.push(randomNumber);
      return item;
    });

    setBet({
      betType: betTypesForBetsContainer.RANDOM,
      odd: null,
      result: randomResult,
    });

    setBallCollumns(getSetOfBalls(randomResult));
  };

  // remove prebet(click on trash btn)
  const onRemovePrebetEventListener = () => {
    clearBallInput();
    clearBallColor();
    clearBallsNumbers();
    clearSpecialBet();
  };

  // clear checked balls numbers
  const clearBallsNumbers = () => {
    setBet({
      betType: betTypesForBetsContainer.CUSTOM,
      odd: null,
      result: [],
    });

    setBallCollumns(getSetOfBalls());
  };

  // clear inputs with balls
  const clearBallInput = () => {
    let inputNow = document.getElementsByClassName("bet-input-numbers");
    for (let x = 0; x < inputNow.length; x++) {
      inputNow[x].value = "";
    }
  };

  // clear checked ball color
  const clearBallColor = () => {
    setBetForColors({
      ...betForColors,
      ...{ odd: null, result: [] },
    });
  };

  // clear special bet
  const clearSpecialBet = () => {
    setBetSpecials({
      betType: null,
      odd: null,
      result: [],
    });
  };

  // get new set of balls for render balls
  const getSetOfBalls = (ckeckedBalls = []) => {
    const ballColumnsCopy = { ...ballsColumns };
    for (let [color, balls] of Object.entries(ballColumnsCopy)) {
      for (let number of Object.keys(balls)) {
        ballColumnsCopy[color][number] = ckeckedBalls.includes(Number(number));
      }
    }
    return ballColumnsCopy;
  };

  // get new set of balls for one color
  const getSetOfBallsByOneColor = (color = "") => {
    const ballColumnsCopy = { ...ballsColumns };
    for (const number of Object.keys(ballColumnsCopy[color])) {
      ballColumnsCopy[color][number] = true;
    }

    return ballColumnsCopy;
  };

  // change active tab in odd color tab
  const changeActiveTab = (event) => {
    clearBallsNumbers();
    clearSpecialBet();
    const betTypeTab = event.currentTarget.getAttribute("data-tab-alias");
    setBetForColors({
      betType: betTypeTab,
      odd: null,
      result: [],
    });
  };

  // click on ball color cell
  const onBallColorClickEventListener = (event) => {
    clearBallsNumbers();
    clearSpecialBet();
    const ballColor = event.currentTarget.getAttribute("data-color");
    // const odd = event.currentTarget.getAttribute("data-odd");

    let ballColors = [...betForColors.result];
    if (betForColors.result.includes(ballColor)) {
      ballColors.splice(betForColors.result.indexOf(ballColor), 1);
      setBetForColors({
        betType: betForColors.betType,
        odd: null,
        result: ballColors,
      });
    } else {
      ballColors = [...betForColors.result, ballColor];
    }

    if (
      betForColors.betType === "MOST_FREQUENT_COLOR" &&
      betForColors.result.length >= 2
    ) {
      toastreact({
        type: toastMessageTypes.WARN,
        title: t("oddsContent.pickMaxColors").replace(
          "MAX_CHECKED_BALL_COLOR",
          2
        ),
      });
      return;
    }

    if (
      betForColors.result.length >= MAX_CHECKED_BALL_COLOR &&
      !event.currentTarget.classList.contains("active")
    ) {
      toastreact({
        type: toastMessageTypes.WARN,
        title: t("oddsContent.pickMaxColors").replace(
          "MAX_CHECKED_BALL_COLOR",
          MAX_CHECKED_BALL_COLOR
        ),
      });
      return;
    }
    setBetForColors({
      betType: betForColors.betType,
      odd: null,
      result: ballColors,
    });
  };

  // click on buttons from special bets container
  const onSpecialBetEventListener = (e) => {
    clearBallsNumbers();
    clearBallColor();
    const specialBetType = e.currentTarget.getAttribute(
      "data-special-bet-type"
    );
    const specialBetValue = e.currentTarget.getAttribute(
      "data-special-bet-value"
    );

    setBetSpecials({
      betType: specialBetType,
      odd: null,
      result: [specialBetValue],
    });
  };

  // check if all balls are the same color
  const isAllBallsOfOneColor = (predictedArray) => {
    let ballsColor = "";
    for (const [color, ballnumbers] of Object.entries({
      ...ballsColorColumns,
    })) {
      // if all balls are the same color than return color name
      if (
        Object.keys(ballnumbers).filter((ballNumber) => {
          return !predictedArray.includes(Number(ballNumber));
        }).length === 0
      ) {
        ballsColor = color;
      }
    }

    return ballsColor;
  };

  // replace color name by its number value and return array of these values
  const getArrayWithColorNumberAlias = (colorsNamesArr) => {
    let numbersOfColors = [];
    for (const colorName of colorsNamesArr) {
      numbersOfColors.push(colorsAsNumbers[colorName]);
    }
    return numbersOfColors;
  };

  // check if the current bet is the special bet or not
  const isSpecialBet = (betTip) => {
    return (
      betTip === betTypesForBetsContainer.FIRST_NUMBER_EVEN_ODD ||
      betTip === betTypesForBetsContainer.FIRST_NUMBER_UNDER_OVER ||
      betTip === betTypesForBetsContainer.PRE_NUMBER_EVEN_ODD ||
      betTip === betTypesForBetsContainer.PRE_NUMBER_SUM_UNDER_OVER ||
      betTip === betTypesForBetsContainer.MORE_EVEN_OR_ODD
    );
  };

  // get the correct value of bet's lines for each SYSTEM bet
  const getLinesForSystemBet = (winningPlanArray, betType, systemBetLength) => {
    let lineCountForSystemBet = 0;
    for (const planForOneBet of winningPlanArray) {
      if (Number(planForOneBet.BetType) !== betType) continue;
      if (Number(planForOneBet.Specifier) !== systemBetLength) continue;
      lineCountForSystemBet = planForOneBet.Value;
    }
    return lineCountForSystemBet;
  };

  const OddsOnKeyPressEventListener = (ev) => {
    switch (ev.key) {
      case "+":
        buttonAddBet.current.click();
        break;
      case "-":
        buttonRemoveBet.current.click();
        break;
      case "r":
        buttonSelectRandomBet.current.click();
        break;
      case "c":
        buttonSelectAllColorsBet.current.click();
        break;
      case "p":
        buttonPreBallNumber.current.click();
        break;
      case "s":
        break;
      case "k":
        break;
      case "o":
        break;
      case "h":
        break;
      case "g":
        break;
      case "d":
        break;
    }
  };

  const validationAddBET = () => {
    return (
      bet.result.length >= 6 ||
      (bet.result.length === 1 &&
        bet.betType === betTypesForBetsContainer.PRE_BALL_NUMBER) ||
      (betForColors.result.length > 0 && betForColors.result.length !== 3) ||
      betSpecials.result[0]
    );
  };

  // click on add bet button(add bet in betslip)
  const onAddBetClickEventLisener = () => {
    if (!validationAddBET())
      return console.log("valid BET: " + !!validationAddBET());
    let activeBetState = {};
    clearBallInput();
    if (bet.result.length > 0) {
      activeBetState = { ...bet };
    } else
      activeBetState =
        betForColors.result.length > 0
          ? { ...betForColors }
          : { ...betSpecials };

    const predictedResultForBet = activeBetState.result.sort((a, b) => a - b);
    const betTip = activeBetState.betType;

    // data for betslip
    let tip = "";
    let odds = 1;
    let stake = state.lifecycleData.minStake;
    const betType =
      bet.result.length === 6
        ? betTypeForBetName["RANDOM"]
        : betTypeForBetName[betTip];
    let resultForRequest = predictedResultForBet.join(","); // revert color name into theirs number value: [red, green] => [1, 2]

    // for PRE_BALL_NUMBER bet
    if (
      predictedResultForBet.length === 1 &&
      betTip === betTypesForBetsContainer.PRE_BALL_NUMBER
    ) {
      tip = betTypesForBetBetslip[betTypesForBetsContainer.PRE_BALL_NUMBER];
      // get odd value from Winning plan
      odds = Number(
        getOddByBetTypeAndSpecifier(
          betTypeForBetName[betTypesForBetsContainer.PRE_BALL_NUMBER],
          state.lifecycleData.WinningPlan
        )
      );
    }

    // for special bets
    if (predictedResultForBet.length === 1 && isSpecialBet(betTip)) {
      tip = betTypesForBetBetslip[betTip];
      odds = getOddByBetTypeAndSpecifier(
        betTypeForBetName[betTypesForBetsContainer.FIRST_NUMBER_UNDER_OVER],
        state.lifecycleData.WinningPlan,
        specifierValueForSpecialBets[predictedResultForBet.toString()]
      );
      resultForRequest = specifierValueForSpecialBets[
        predictedResultForBet.toString()
      ].toString();
    }

    // for CUSTOM and RANDOM bets
    if (
      betTip === betTypesForBetsContainer.CUSTOM ||
      betTip === betTypesForBetsContainer.RANDOM
    ) {
      tip =
        predictedResultForBet.length === 6
          ? betTypesForBetBetslip[betTypesForBetsContainer.RANDOM]
          : betTypesForBetBetslip[betTypesForBetsContainer.CUSTOM][
              `SYSTEM6${predictedResultForBet.length}`
            ];

      stake =
        predictedResultForBet.length > 6
          ? Number(
              getLinesForSystemBet(
                state.lifecycleData.WinningPlan,
                betTypeForBetName.CUSTOM,
                predictedResultForBet.length
              )
            ) * state.lifecycleData.minSystemStake
          : stake;

      odds = 0;

      if (predictedResultForBet.length === 6) {
        const ballsColor = isAllBallsOfOneColor(predictedResultForBet);
        tip = Object.keys({ ...ballsColorColumns }).includes(ballsColor)
          ? `allColor${ballsColor}`
          : tip;
      }
    }

    // for ALL_COLORS bet
    let betsForAllColorType = [];
    let index = 0;
    if (betTip === betTypesForBetsContainer.ALL_COLORS) {
      for (const [color, ballnumbers] of Object.entries({
        ...ballsColorColumns,
      })) {
        odds = getOddByBetTypeAndSpecifier(
          betTypeForBetName[betTypesForBetsContainer.RANDOM],
          state.lifecycleData.WinningPlan
        );
        const result_ = Object.keys(ballnumbers).map((number) =>
          Number(number)
        );
        betsForAllColorType[index++] = {
          [`allColor${color}`]: {
            result: result_,
            odds: odds,
            stake: stake,
            tip: `allColor${color}`,
            win: odds * stake,
            betType: betType,
            resultForRequest: result_.join(","),
          },
        };
      }
    }

    // for bet with colors MOST_FREQUENT_COLOR and FIRST_BALL_COLOR and LAST_BALL_COLOR
    if (
      betTip === betTypesForBetsContainer.MOST_FREQUENT_COLOR ||
      betTip === betTypesForBetsContainer.FIRST_BALL_COLOR ||
      betTip === betTypesForBetsContainer.LAST_BALL_COLOR
    ) {
      tip = betTypesForBetBetslip[betTip];
      odds = getOddByBetTypeAndSpecifier(
        betTypeForBetName[betTip], // 8, 7, 10
        state.lifecycleData.WinningPlan,
        specifierValueForSpecialBets[`${betTip}${predictedResultForBet.length}`] // MOST_FREQUENT_COLOR4, MOST_FREQUENT_COLOR1...
      );
      resultForRequest = getArrayWithColorNumberAlias(
        predictedResultForBet
      ).join(","); // colors numbers array
    }

    let bets = {
      [tip]: {
        result: predictedResultForBet,
        odds: odds,
        stake: stake,
        tip: `${tip}`,
        win: odds * stake,
        betType: betType,
        resultForRequest: resultForRequest,
      },
    };

    const betsObject = { ...state.betsObject };
    if (betTip === betTypesForBetsContainer.ALL_COLORS) {
      betsObject[state.lifecycleData.Round] = betsForAllColorType;
    } else {
      if (betAlreadyInBetsObject(state.betsObject, bets)) {
        betsObject[state.lifecycleData.Round] = [
          ...(state.betsObject[state.lifecycleData.Round] || []),
        ];
      } else {
        betsObject[state.lifecycleData.Round] = [
          ...(state.betsObject[state.lifecycleData.Round] || []),
          bets,
        ];
      }
    }
    dispatch({
      type: "ADD_BET_IN_BETSLIP",
      payload: betsObject,
    });
    onRemovePrebetEventListener();
  };

  // if countdown timer value is less than 10000 block the betslip
  const blockBetslip = (timeInMs) => {
    console.log(timeInMs);
    if (timeInMs >= 0 && timeInMs <= 1000) {
      console.log("all");
      setDisableBetslip("all");
      // remove bets from betslip
      dispatch({
        type: "ADD_BET_IN_BETSLIP",
        payload: {},
      });
    }

    if (timeInMs > 1000) {
      // block adding bets in betslip
      console.log("none");
      setDisableBetslip("none");
    }
  };

  if (state.lifecycleData.minStake === -1) {
    return (
      <h5 style={{ textAlign: "center" }}>{t("oddsContent.waitUntilDrawingEnded")}</h5>
    );
  } else {
    return (
      <div className={"odds-outer"} style={{ pointerEvents: disableBetslip }}>
        <div className="flex-row">
          <div className="flex-col-12 fl-cntr-vcenter d-flex">
            <span className="round-label">
              {t("oddsContent.roundNumber")}{" "}
              {state.currentLifecycleState === lifecycleStates.DRAW ? (
                <>
                  <strong className="warning">
                    {state.Round > 0 ? state.Round : 0}
                  </strong>{" "}
                  {t("oddsContent.isDrawing")}
                </>
              ) : (
                <>
                  <strong className="warning">
                    {state.Round > 0 ? state.Round : 0}
                  </strong>{" "}
                  {t("oddsContent.startsIn")}:
                  <div className="event-odds-timer">
                    {state.lifecycleData.Round > 0 && (
                      <Countdown
                        callbackForTimeLimit={blockBetslip}
                        timeLimit={6000}
                        timeInMs={state.lifecycleData.Countdown * 1000 - 1000}
                        round={state.lifecycleData.Round}
                      />
                    )}
                  </div>
                </>
              )}
            </span>
          </div>
          <div className="flex-col-9">
            <div className="flex-row fl-cntr-end fl-cntr-vcenter action-main-btns">
              <div
                ref={buttonRemoveBet}
                className={cn("onebtn align-center remove-checked-btn", {
                  active:
                    bet.result.length > 0 ||
                    betForColors.result.length > 0 ||
                    betSpecials.result[0],
                })}
                onClick={onRemovePrebetEventListener}
              ></div>
              <div
                ref={buttonAddBet}
                className={cn(
                  "onebtn align-center add-bet d-flex fl-cntr-vcenter",
                  { active: validationAddBET() }
                )}
                onClick={onAddBetClickEventLisener}
              >
                {t("oddsContent.addBet")}
              </div>
            </div>
          </div>
        </div>
        <div className="divider"></div>
        <div className="flex-row odds-content">
          <div className="flex-col-12 ">
            <div className="flex-row justify-around">
              <div
                ref={buttonSelectRandomBet}
                className={cn("btn align-center ball-bet-type", {
                  ["btn-info"]: bet.betType === betTypesForBetsContainer.RANDOM,
                  ["btn-default"]:
                    bet.betType !== betTypesForBetsContainer.RANDOM,
                })}
                onClick={onRandomClickEventListener}
              >
                {t(betTypesForBetsContainer.RANDOM)}
              </div>
              <div
                ref={buttonSelectAllColorsBet}
                className={cn("btn align-center ball-bet-type", {
                  ["btn-info"]:
                    bet.betType === betTypesForBetsContainer.ALL_COLORS,
                  ["btn-default"]:
                    bet.betType !== betTypesForBetsContainer.ALL_COLORS,
                })}
                onClick={onAllColorsClickEventListener}
              >
                {t(betTypesForBetsContainer.ALL_COLORS)}
              </div>
              <div
                ref={buttonPreBallNumber}
                style={{ paddingRight: 0, paddingLeft: 0 }}
                className={cn("btn align-center ball-bet-type px-0", {
                  ["btn-info"]:
                    bet.betType === betTypesForBetsContainer.PRE_BALL_NUMBER,
                  ["btn-default"]:
                    bet.betType !== betTypesForBetsContainer.PRE_BALL_NUMBER,
                })}
                onClick={onPreBallsNumberClickEventListener}
              >
                {t(betTypesForBetsContainer.PRE_BALL_NUMBER)}
              </div>
            </div>
            <div className="input-numbers">
              <input
                className={cn("bet-input-numbers", {
                  "input-numbers-wrong": wrong,
                })}
                min="0"
                max="48"
                type="number"
                onChange={onInputClickEventListener}
              ></input>
              <input
                className={cn("bet-input-numbers", {
                  "input-numbers-wrong": wrong,
                })}
                min="0"
                max="48"
                type="number"
                onChange={onInputClickEventListener}
              ></input>
              <input
                className={cn("bet-input-numbers", {
                  "input-numbers-wrong": wrong,
                })}
                min="0"
                max="48"
                type="number"
                onChange={onInputClickEventListener}
              ></input>
              <input
                className={cn("bet-input-numbers", {
                  "input-numbers-wrong": wrong,
                })}
                min="0"
                max="48"
                type="number"
                onChange={onInputClickEventListener}
              ></input>
              <input
                className={cn("bet-input-numbers", {
                  "input-numbers-wrong": wrong,
                })}
                min="0"
                max="48"
                type="number"
                onChange={onInputClickEventListener}
              ></input>
              <input
                className={cn("bet-input-numbers", {
                  "input-numbers-wrong": wrong,
                })}
                min="0"
                max="48"
                type="number"
                onChange={onInputClickEventListener}
              ></input>
            </div>
            <div className="balls-container flex-row justify-around">
              {Object.keys(ballsColumns).map((column) => {
                return (
                  <div key={column} className={`balls-column column-${column}`}>
                    {Object.keys(ballsColumns[column]).map((number, index) => {
                      return (
                        <React.Fragment key={`${number}${column}`}>
                          <div
                            onClick={onBallClickEventListener}
                            className={cn(`spaceholder-balls flex-row`, {
                              [`color-alias`]:
                                Object.keys(ballsColumns[column]).length - 1 ===
                                index,
                              [`${column}`]: ballsColumns[column][number],
                              active: ballsColumns[column][number],
                            })}
                            data-ball-number={number}
                            data-color-column={column}
                          >
                            <span className="ball-number">{number}</span>
                          </div>
                          {Object.keys(ballsColumns[column]).length - 1 ===
                            index && (
                            <div
                              className={"color-alias-outer"}
                              onClick={() => checkNumbersByColor(column)}
                            >
                              <span
                                className={`color-alias alias-${column}`}
                              ></span>
                            </div>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </div>
                );
              })}
            </div>
            <div className="divider"></div>
            <div className="tabs">
              <nav className={cn("tabs-titles")}>
                <div
                  data-tab-alias={betTypesForBetsContainer.MOST_FREQUENT_COLOR}
                  onClick={changeActiveTab}
                  className={cn("tabs-titles-item", {
                    active:
                      betForColors.betType ===
                      betTypesForBetsContainer.MOST_FREQUENT_COLOR,
                  })}
                >
                  {t(betTypesForBetsContainer.MOST_FREQUENT_COLOR)}
                </div>
                <div
                  data-tab-alias={betTypesForBetsContainer.FIRST_BALL_COLOR}
                  onClick={changeActiveTab}
                  className={cn("tabs-titles-item", {
                    active:
                      betForColors.betType ===
                      betTypesForBetsContainer.FIRST_BALL_COLOR,
                  })}
                >
                  {t(betTypesForBetsContainer.FIRST_BALL_COLOR)}
                </div>
                <div
                  data-tab-alias={betTypesForBetsContainer.LAST_BALL_COLOR}
                  onClick={changeActiveTab}
                  className={cn("tabs-titles-item", {
                    active:
                      betForColors.betType ===
                      betTypesForBetsContainer.LAST_BALL_COLOR,
                  })}
                >
                  {t(betTypesForBetsContainer.LAST_BALL_COLOR)}
                </div>
              </nav>
              <div className="tabs-content d-flex justify-around">
                {Object.values(colors).map((color, index) => {
                  return (
                    <div
                      key={`${index}_${color}`}
                      onClick={onBallColorClickEventListener}
                      data-color={color}
                      className={cn(`ball-color alias-${color}`, {
                        active: betForColors.result.includes(color),
                      })}
                    ></div>
                  );
                })}
              </div>
            </div>
          </div>

          <div className="flex-col-9 padding-x">
            <div className="special-bet-block">
              <p className="special-bet-title align-center">
                {t(betTypesForBetsContainer.FIRST_NUMBER_EVEN_ODD)}
              </p>
              <div className="d-flex justify-around special-bet-main">
                <span
                  className={cn("btn align-center special-cell", {
                    active:
                      betSpecials.result[0] === "EVEN" &&
                      betSpecials.betType ===
                        betTypesForBetsContainer.FIRST_NUMBER_EVEN_ODD,
                  })}
                  onClick={onSpecialBetEventListener}
                  data-special-bet-type={
                    betTypesForBetsContainer.FIRST_NUMBER_EVEN_ODD
                  }
                  data-special-bet-value={"EVEN"}
                >
                  {t("EVEN")}
                </span>
                <span
                  className={cn("btn align-center special-cell", {
                    active:
                      betSpecials.result[0] === "ODD" &&
                      betSpecials.betType ===
                        betTypesForBetsContainer.FIRST_NUMBER_EVEN_ODD,
                  })}
                  onClick={onSpecialBetEventListener}
                  data-special-bet-type={
                    betTypesForBetsContainer.FIRST_NUMBER_EVEN_ODD
                  }
                  data-special-bet-value={"ODD"}
                >
                  {t("ODD")}
                </span>
              </div>
            </div>
            <div className="divider"></div>

            <div className="special-bet-block">
              <p className="special-bet-title align-center">
                {t(betTypesForBetsContainer.FIRST_NUMBER_EVEN_ODD)}
              </p>
              <div className="d-flex justify-around special-bet-main">
                <span
                  className={cn("btn align-center special-cell", {
                    active:
                      betSpecials.result[0] === "UNDER" &&
                      betSpecials.betType ===
                        betTypesForBetsContainer.FIRST_NUMBER_UNDER_OVER,
                  })}
                  onClick={onSpecialBetEventListener}
                  data-special-bet-type={
                    betTypesForBetsContainer.FIRST_NUMBER_UNDER_OVER
                  }
                  data-special-bet-value={"UNDER"}
                >
                  {t("UNDER")} {state.lifecycleData.FirstNumberUOText}
                </span>
                <span
                  className={cn("btn align-center special-cell", {
                    active:
                      betSpecials.result[0] === "OVER" &&
                      betSpecials.betType ===
                        betTypesForBetsContainer.FIRST_NUMBER_UNDER_OVER,
                  })}
                  onClick={onSpecialBetEventListener}
                  data-special-bet-type={
                    betTypesForBetsContainer.FIRST_NUMBER_UNDER_OVER
                  }
                  data-special-bet-value={"OVER"}
                >
                  {t("OVER")} {state.lifecycleData.FirstNumberUOText}
                </span>
              </div>
            </div>
            <div className="divider"></div>

            <div className="special-bet-block">
              <p className="special-bet-title align-center">
                {t(betTypesForBetsContainer.PRE_NUMBER_EVEN_ODD)}
              </p>
              <div className="d-flex justify-around special-bet-main">
                <span
                  className={cn("btn align-center special-cell", {
                    active:
                      betSpecials.result[0] === "EVEN" &&
                      betSpecials.betType ===
                        betTypesForBetsContainer.PRE_NUMBER_EVEN_ODD,
                  })}
                  onClick={onSpecialBetEventListener}
                  data-special-bet-type={
                    betTypesForBetsContainer.PRE_NUMBER_EVEN_ODD
                  }
                  data-special-bet-value={"EVEN"}
                >
                  {t("EVEN")}
                </span>
                <span
                  className={cn("btn align-center special-cell", {
                    active:
                      betSpecials.result[0] === "ODD" &&
                      betSpecials.betType ===
                        betTypesForBetsContainer.PRE_NUMBER_EVEN_ODD,
                  })}
                  onClick={onSpecialBetEventListener}
                  data-special-bet-type={
                    betTypesForBetsContainer.PRE_NUMBER_EVEN_ODD
                  }
                  data-special-bet-value={"ODD"}
                >
                  {t("ODD")}
                </span>
              </div>
            </div>
            <div className="divider"></div>

            <div className="special-bet-block">
              <p className="special-bet-title align-center">
                {t(betTypesForBetsContainer.PRE_NUMBER_SUM_UNDER_OVER)}
              </p>
              <div className="d-flex justify-around special-bet-main">
                <span
                  className={cn("btn align-center special-cell", {
                    active:
                      betSpecials.result[0] === "UNDER" &&
                      betSpecials.betType ===
                        betTypesForBetsContainer.PRE_NUMBER_SUM_UNDER_OVER,
                  })}
                  onClick={onSpecialBetEventListener}
                  data-special-bet-type={
                    betTypesForBetsContainer.PRE_NUMBER_SUM_UNDER_OVER
                  }
                  data-special-bet-value={"UNDER"}
                >
                  {t("UNDER")} {state.lifecycleData.PreNumbersUOText}
                </span>
                <span
                  className={cn("btn align-center special-cell", {
                    active:
                      betSpecials.result[0] === "OVER" &&
                      betSpecials.betType ===
                        betTypesForBetsContainer.PRE_NUMBER_SUM_UNDER_OVER,
                  })}
                  onClick={onSpecialBetEventListener}
                  data-special-bet-type={
                    betTypesForBetsContainer.PRE_NUMBER_SUM_UNDER_OVER
                  }
                  data-special-bet-value={"OVER"}
                >
                  {t("OVER")} {state.lifecycleData.PreNumbersUOText}
                </span>
              </div>
            </div>

            <div className="divider"></div>

            <div className="special-bet-block">
              <p className="special-bet-title align-center">
                {t(betTypesForBetsContainer.MORE_EVEN_OR_ODD)}
              </p>
              <div className="d-flex justify-around special-bet-main">
                <span
                  className={cn("btn align-center special-cell", {
                    active:
                      betSpecials.result[0] === "EVEN" &&
                      betSpecials.betType ===
                        betTypesForBetsContainer.MORE_EVEN_OR_ODD,
                  })}
                  onClick={onSpecialBetEventListener}
                  data-special-bet-type={
                    betTypesForBetsContainer.MORE_EVEN_OR_ODD
                  }
                  data-special-bet-value={"EVEN"}
                >
                  {t("EVEN")}
                </span>
                <span
                  className={cn("btn align-center special-cell", {
                    active:
                      betSpecials.result[0] === "ODD" &&
                      betSpecials.betType ===
                        betTypesForBetsContainer.MORE_EVEN_OR_ODD,
                  })}
                  onClick={onSpecialBetEventListener}
                  data-special-bet-type={
                    betTypesForBetsContainer.MORE_EVEN_OR_ODD
                  }
                  data-special-bet-value={"ODD"}
                >
                  {t("ODD")}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default React.memo(OddsFoBet);